/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionConflictsControllerFindAllQueryResponse, QuestionConflictsControllerFindAllQueryParams, QuestionConflictsControllerFindAll401, QuestionConflictsControllerFindAll403 } from "../../models/checklistsController/QuestionConflictsControllerFindAll";

function getQuestionConflictsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-question-conflicts` as const }  
  return res
}

/**
 * @summary List checklist question conflicts
 * {@link /api/v1/checklist-question-conflicts}
 */
export async function questionConflictsControllerFindAll(params?: QuestionConflictsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<QuestionConflictsControllerFindAllQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindAll401 | QuestionConflictsControllerFindAll403>, unknown>({ method : "GET", url : getQuestionConflictsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}